import storefront from "../../global/storefront";
import unwrapNodes from "../unwrapNodes";
import addProductHelpers from "../addProductHelpers";
import getBuyer from "../getBuyer";
import { product, productByHandle } from "../../global/storefront/queries";

const cache = {};
const resolved = {};

// The resolved product, for callers that need it during a render rather than a
// tick later — a component remounting on an already-fetched product can show it
// immediately instead of blanking until its promise settles.
export function getCachedProduct(id) {
  return resolved[id] || null;
}

export default function fetchProduct(id, queryType = "id") {
  if (id in cache) {
    return cache[id];
  }

  cache[id] = storefront
    .request({
      query: queryType === "handle" ? productByHandle : product,
      variables: {
        [queryType]: id,
        // buyer: getBuyer(),
      },
    })
    .then(({ data }) => {
      const output = unwrapNodes(data.product);

      if (!output) return;
      addProductHelpers(output);
      resolved[id] = output;

      return output;
    });

  return cache[id];
}
